import { WSElement, WSSectionToolbar } from "@wingspanhq/fe-component-library";
import {
  IPayeeEngagementResponse,
  IPayeeResponse,
  IWorkLog
} from "@wingspanhq/payments/dist/interfaces";
import { usePayableQuery } from "../../../Invoices/screens/payables/PayableDetails";
import { DataView } from "../../../shared/components/DataView";
import { getPayeeName } from "../../Payees/selectors/getPayeeNames";
import { getWorkLogPayerStatusCellProps } from "../utils/getWorkLogPayerStatusCellProps";

type Props = {
  shimmer?: boolean;
  workLog?: IWorkLog;
  payee?: IPayeeResponse;
  payerPayeeEngagement?: IPayeeEngagementResponse;
};

export const WorkLogAssignmentInfoPayerView: React.FC<Props> = props => {
  const queryPayable = usePayableQuery(props.workLog?.invoiceId!, {
    enabled: !!props.workLog?.invoiceId
  });

  const statusCellProps = props.workLog
    ? getWorkLogPayerStatusCellProps({
        workLog: props.workLog,
        payable: queryPayable.data
      })
    : undefined;

  const payeeName = props.payee ? getPayeeName(props.payee) : undefined;

  return (
    <WSElement>
      <WSSectionToolbar title="Assignment information" />
      <DataView
        shimmer={props.shimmer}
        data={[
          {
            label: "Assignment name",
            value: props.payerPayeeEngagement?.engagementName
          },
          {
            label: "Status",
            secondaryText:
              statusCellProps?.text || statusCellProps?.secondaryText,
            pill: statusCellProps?.pill,
            hideValue: true
          },
          { label: "Contractor name", value: payeeName }
        ]}
      />
    </WSElement>
  );
};
